/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/**
 * Metrics event used for Metrics.event() to trigger pageState change.
 */
export enum MetricsEvents {
  PAGE_LOAD_DONE = 'exc.metrics.pageState.load.done',
  PAGE_LOAD_START = 'exc.metrics.pageState.load.start',
  SPINNER_DONE = 'exc.metrics.pageState.spinner.done',
  SPINNER_START = 'exc.metrics.pageState.spinner.start',
}
